export const getUrlParameter = (name: any) => {
  var results = new RegExp('[\\?&]' + name + '=([^&#?]*)').exec(window.location.href);
  if (results==null){ return null; }
  else { return results[1] || 0; }
}

export const scrollError = () => {
  setTimeout(function () {
    let list:any = document.getElementsByClassName('error');
    if (list.length > 0) {
      list[0]["parentNode"].scrollIntoView();
    }
  }, 100);
}

export const getSS = (key:any) => {
  let data = sessionStorage.getItem(key)
  if (!data) {
    return false
  }
  if (data) {
    if (data === 'true') {
      return true
    }
    if (data.substring(0,1) !== '{') {
      return data
    } else {
      return JSON.parse(data)
    }
  }
}

export const setSS = (key:any, value:any) => {
  if (typeof value === 'string') {
    sessionStorage.setItem(key, value)
  } else {
    sessionStorage.setItem(key, JSON.stringify(value))
  }
}

export const renderDate = (isoString:any) => {
  let m = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
  let date = new Date(isoString)
  let year = date.getFullYear()
  let month = date.getMonth()
  let day = date.getDate()
  return day + ' ' + m[month] + ' ' + year
}

export const cleanObject = (obj: any) => {
  for (var propName in obj) {
    if (!obj[propName]) {
      delete obj[propName];
    }
  }
  return obj
}

export const loadIndexPage = async (navigate:any, url: any) => {
  sessionStorage.removeItem('donation')
  sessionStorage.removeItem('homepage')
  sessionStorage.removeItem('payment')
  sessionStorage.removeItem('payment_regular')
  sessionStorage.removeItem('api-error')
  sessionStorage.removeItem('dataLayerInitialPush')
  sessionStorage.removeItem('dataLayerInitialPush2')
  navigate(`/donate/${url}`)
}

// Check for a google analytics client id and if found return it
// (otherwise return an empty string)
export const googleAnalyticsClientID = () => {

  const location = (window as any).location

  // Utility to get a query string param
  const getQueryStringParam = function(url: any, name: any) {
      try {
          name = name.replace(/[[\]]/g, "\\$&");
          var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
              results = regex.exec(url);
          if (!results) return '';
          if (!results[2]) return '';
          return decodeURIComponent(results[2].replace(/\+/g, " "));
      } catch (e) {
          // oh well, we tried
      }
      return "";
  };

  //  Utility to parse a google analytics client id
  const parseClientID = function(s: any) {
      if (s === '') {
          return '';
      }
      try {
          let parts = s.split('.');
          // google uses the 3rd and 4th part of the `.` seperated string for the client id
          let clientID = '';
          if (parts.length > 2) {
              clientID = parts[2];
          }
          if (parts.length > 3) {
              clientID = clientID + '.' + parts[3];
          }
          return clientID;
      } catch (e) {
          // oh well, we tried
      }
      return '';
  };

  // First check for a query string parameter
  let result = parseClientID(getQueryStringParam(location.href, '_ga'));

  const getCookie = (name: any) => {
    let cookieArray = document.cookie.split(";");
    for(let i = 0; i < cookieArray.length; i++) {
        let cookiePair = cookieArray[i].split("=");
        if (name === cookiePair[0].trim()) {
            return decodeURIComponent(cookiePair[1]);
        }
    }
    // Return null if not found
    return null;
}
  // If that didn't work, check cookies
  if (result === '' && getCookie('_ga')) {
      result = parseClientID(getCookie('_ga'));
  }
  return result;
}